/**
 * Normalize visitor email for stable comparison (trim + lowercase).
 */
export const normalizeVisitorEmail = (value?: string | null): string => (value ?? '').trim().toLowerCase();

/**
 * Normalize visitor phone for comparison (trim + remove spaces).
 */
export const normalizeVisitorPhone = (value?: string | null): string => (value ?? '').trim().replace(/\s/g, '');

export interface PrimaryVisitorContactSnapshot {
  email: string;
  phone: string;
}

/**
 * Builds a comparable snapshot for the primary visitor (first in the list / visit-level fallback).
 */
export const snapshotPrimaryVisitorContactFromVisit = (visit: {
  email?: string;
  phone?: string;
  visitors?: Array<{ email?: string; phone?: string; visitor_phone?: string }>;
}): PrimaryVisitorContactSnapshot => {
  const v0 = visit.visitors?.[0];
  const emailRaw = v0?.email ?? visit.email ?? '';
  const phoneRaw = v0?.phone ?? v0?.visitor_phone ?? visit.phone ?? '';

  return {
    email: normalizeVisitorEmail(emailRaw),
    phone: normalizeVisitorPhone(phoneRaw),
  };
};

/**
 * True when the first visitor's email or phone differs from the snapshot taken when the visit was loaded.
 */
export const didPrimaryVisitorEmailOrPhoneChange = (
  baseline: PrimaryVisitorContactSnapshot | null | undefined,
  visitors: Array<{ email?: string; phone?: string }> | undefined,
): boolean => {
  if (!baseline || !visitors?.[0]) {
    return false;
  }

  const v = visitors[0];
  return normalizeVisitorEmail(v.email) !== baseline.email || normalizeVisitorPhone(v.phone) !== baseline.phone;
};
